export default function flatRelationships(relations) {
  let flat = {};
  Object.entries(relations).forEach(([key, value]) => {
    flat[key] = value.data;
  });
  return flat;
}
